import React, { Component } from "react";
import { Row, Col, Tooltip } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RecurringIcon from "../../../../../../../assets/icons/recurring.svg";
import { SecondaryButtonComponent } from "../../../../../../../CommonComponents/commonStyles";
import Contents from '../../../../../../../CommonComponents/ContentMessages';
import Highlighter from "react-highlight-words";
import {
  LabelDataHeading,
  ValueDataHeading,
  Underlined,
  ContentDivider,
  CharityHeading,
  MobileIconStyle
} from "../../../style";

import { fetchGrantData } from "../../../actions";
import { enableRegrant } from "../../../../RecommendGrant/actions";
import CheckRegrantOptions from "../../ContentComponent/Regrant";
import { cancelTxnSchedule } from "../../../actions";
import { AlertMessagePrimary } from "../../AlertPopUp/AlertPopUp";
import { getPrimaryAccount } from "../../../../../../../utils/sessionUtil";
import formatter from "../../../../../../../utils/formatter";
import gaIcon from "../../../../../../../assets/icons/grant-agreement.svg";
import {
  milliToDate,
  initiateTracking,
  recordError
} from "../../../../../../../utils/commonUtil";
import PurposeSummary from '../../../../../Components/PurposeSummary/PurposeSummary';
import { getAlert } from "../../../../../../NPA/Pages/Step1Setup/Components/UtilFunctions";
import queryString from "query-string";

export const renderAmount = text => {
  if (text !== "--") {
    return formatter({
      value: text,
      fieldSuffix: "Dollars"
    });
  } else {
    return text;
  }
};

class ExchangesCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: false,
      id: ""
    };
    this.handlePop = this.handlePop.bind(this);
  }

  cancelSingle() {
    this.setState({ popup: !this.state.popup });
    this.props.cancelTxnSchedule({
      method: "PUT",
      page: "grantsActivity",
      url: `/donor-portal/api/grant/${getPrimaryAccount().userId}/cancelGrant`,
      data: {
        accountId: getPrimaryAccount().userId,
        grantId: this.props.data.txnId,
        grantType: "single"
      }
    });
  }

  handlePop(id) {
    this.setState({ popup: !this.state.popup, id });
  }

  viewGrants = (id, type, data) => {
    try {
      let checkClearedDate = data.checkClearedDate;
      if (type === "single") {
        this.props.history.push({
          pathname: "/grants/activity/view",
          search: queryString.stringify({ grantId: id }),
          state: { checkClearedDate }
        });
      } else {
        this.props.push({
          pathname: "/grants/activity/view",
          search: queryString.stringify({ grantId: id }),
          state: { checkClearedDate }
        })
      }
    } catch (error) {
      recordError(error);
    }
  };

  getScheduleType = (a='') => {
    if(a) {
      return a.grantAgreementFlag ? 'Grant Agreement': (a.isRecurring === true ? 'Recurring': 'One Time');
    }
    return;
  }

  render() {
    const { data, search, index } = this.props;
    let enteredDate = milliToDate(data.enteredDate);
    let issueDate = milliToDate(data.dateRequested);
    const purpose = {
      eventName: data.eventName,
      missionaryName: data.missionaryName,
      missionaryLocation: data.missionaryLocation,
      projectName: data.projectName,
      additionalComments: data.additionalComments
    };    
    return (
      <div data-test = "exchangeCard">
        <Contents.Consumer>
          {props => {
            let gaAlerts = props.alert_messages['Grant Activity'] ? props.alert_messages['Grant Activity'] : [];
            let obj = gaAlerts.length ? getAlert(gaAlerts,'Single') : [];
            return (
              <AlertMessagePrimary
              title={(obj.length && obj[0].field_header)||"Cancel"}
              visible={this.state.popup}
              onCancel={() => this.handlePop()}
              onOk={() => this.cancelSingle()}
              width={460}
              cancelText={( obj.length && obj[0].field_alert_button2_text ) || "No, take me back"}
              okText={( obj.length && obj[0].field_alert_button1_text ) || "CONTINUE"}
            >
              {(obj.length && <span dangerouslySetInnerHTML={{__html:obj[0].field_description}} />) || "Are you sure you want to cancel this grant? Do you want to continue?"}
            </AlertMessagePrimary>
            )
          }}
        </Contents.Consumer>
        <Row>
          <Col span={20}>
            <CharityHeading>
              {data.charityName ? (
                <Highlighter
                  id={`exchange-hightlighter-${index}`}
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[search]}
                  autoEscape={true}
                  textToHighlight={data.charityName.toString()}
                />
              ) : (
                <>&mdash;</>
              )}
            </CharityHeading>
          </Col>          
          <ContentDivider />
          <Col span={12}>
            <LabelDataHeading>Entered Date</LabelDataHeading>
            <ValueDataHeading>
              {enteredDate === "Invalid date" ? (
                <div>&mdash;</div>
              ) : (
                enteredDate
              )}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Amount</LabelDataHeading>
            <ValueDataHeading>{renderAmount(data.amount)}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Issued</LabelDataHeading>
            <ValueDataHeading>
              {milliToDate(data.issuedate) === "Invalid Date" ? (
                <>&mdash;</>
              ) : data.issuedate == "0" ? (
                <>&mdash;</>
              ) : (
                milliToDate(data.issuedate)
              )}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Scheduled*</LabelDataHeading>
            <ValueDataHeading>{issueDate}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Purpose</LabelDataHeading>
            <Tooltip
              placement="bottomRight"
              title={<PurposeSummary {...purpose} />}
              trigger="click"
            >
              <Underlined>{data.purpose}</Underlined>
            </Tooltip>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Status</LabelDataHeading>
            <ValueDataHeading>{data.status}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={12}>
            <LabelDataHeading>Check Cleared Date</LabelDataHeading>
            <ValueDataHeading>
              {data.checkClearedDate === 0 ||
              (data.checkClearedDate == "" &&
                milliToDate(data.checkClearedDate) === "Invalid Date") ? (
                <>&mdash;</>
              ) : data.checkClearedDate === 0 ? (
                <>&mdash;</>
              ) : (
                milliToDate(data.checkClearedDate)
              )}
            </ValueDataHeading>
          </Col>
          <Col span={12}>
            <LabelDataHeading>Schedule Type</LabelDataHeading>
            <ValueDataHeading>{this.getScheduleType(data)}</ValueDataHeading>
          </Col>
        </Row>
        <ContentDivider />
        <Row>
          <Col span={8}>
            {(data.status == "Entered" ||
            (data.status == "Research proceeding" &&
              this.props.user.role.access === "All Access")) && (!data.grantAgreementFlag) ? (
              <SecondaryButtonComponent
                onClick={() => this.viewGrants(data.txnId, "single", data)}
              >
                View & Edit
              </SecondaryButtonComponent>
            ) : (
              <SecondaryButtonComponent
                onClick={() => this.viewGrants(data.txnId, "single", data)}
              >
                View&nbsp;
              </SecondaryButtonComponent>
            )}
          </Col>
          <Col span={8} offset={4}>
            {(data.status == "Payment issued" ||
              data.status == "Payment completed") &&
              this.props.user.role.access === "All Access" && (
                <CheckRegrantOptions
                  isMobile="isMobile"
                  txnId={data.txnId}
                  status={data.status}
                  amount={data.amount}
                  history={this.props.history}
                  isRecurring={data.isRecurring}
                  setRegrant={this.props.enableRegrant}
                  availableBalance={data.availableBalance}
                  fetchGrantData={this.props.fetchGrantData}
                />
              )}
            {(data.status == "Entered" ||
              data.status == "Research proceeding" ||
              data.status == "Research complete") &&
              this.props.user.role.access === "All Access" && (!data.grantAgreementFlag) && (
                <Underlined
                  onClick={() => {
                    this.handlePop(data.grantId);
                  }}
                >
                  {data.status == "Cancelled" ? null : "Cancel"}
                </Underlined>
              )}
          </Col>
        </Row>
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => ({
  cancelTxnSchedule: data => dispatch(cancelTxnSchedule(data)),
  fetchGrantData: data => dispatch(fetchGrantData(data)),
  enableRegrant: data => dispatch(enableRegrant()),
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(ExchangesCard)
);
